import React, { useEffect } from 'react';

export default function useOutsideAlerter(ref,close) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (close && ref.current && !ref.current.contains(event.target)) {
                close()
            }
        }
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [ref]);
}
